module.exports = __webpack_public_path__ + "static/media/cursoslibres.839dcdd1.png";